import React from "react";
import { ArrowRight } from "lucide-react";
import { TID } from "../../lib/testIds";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const AnnouncementBar = () => {
  return (
    <div
      data-testid={TID.announcementBar}
      className="w-full bg-[#FF5F1F] text-black text-[13px] md:text-sm font-medium relative z-40"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2.5 flex items-center justify-center gap-3 text-center">
        <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-black/80 animate-accent-pulse" />
        <span className="leading-tight">
          Building an AI feature, modernizing a SaaS platform, or accelerating your roadmap?
        </span>
        <button
          data-testid={TID.announcementCta}
          onClick={() => scrollTo("contact")}
          className="hidden md:inline-flex items-center gap-1.5 font-bold underline underline-offset-4 hover:no-underline"
        >
          Start a Conversation <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
